export function asyncDispatchMiddleware(dispatch, state, history) {
  return (action) => {
    if (typeof action === 'function') {
      return action(dispatch, state, history);
    }

    return dispatch(action);
  };
}
